import { template as template_8b81dd0bffc548689627d552c5e408c4 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_8b81dd0bffc548689627d552c5e408c4(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
